module.exports = __webpack_public_path__ + "img/2.b057f0cf.png";